import { VisitationScheduleInterval } from "../models/VisitationScheduleInterval";
import { VisitationScheduleType } from "../models/VisitationScheduleType";

export const visitationScheduleTypes: Record<
  VisitationScheduleType,
  {
    title: string;
    description: string;
    supportedIntervals: VisitationScheduleInterval[];
  }
> = {
  "2-2-3": {
    title: "2-2-3",
    description:
      "Two nights with one parent, two nights with the other, and three nights alternating weekly.",
    supportedIntervals: ["2-weeks", "4-weeks", "6-weeks", "8-weeks"],
  },
  "2-2-5-5": {
    title: "2-2-5-5",
    description:
      "Two nights with one parent, two nights with the other, and five nights alternating weekly.",
    supportedIntervals: ["2-weeks", "4-weeks", "6-weeks", "8-weeks"],
  },
  "3-3-4-4": {
    title: "3-3-4-4",
    description:
      "Three nights with one parent, three nights with the other, and four nights alternating weekly.",
    supportedIntervals: ["2-weeks", "4-weeks", "6-weeks", "8-weeks"],
  },
  alternating_weekends: {
    title: "Alternating Weekends",
    description:
      "One parent has the children during the week, and the other parent has them on weekends.",
    supportedIntervals: [
      "1-week",
      "2-weeks",
      "3-weeks",
      "4-weeks",
      "5-weeks",
      "6-weeks",
      "7-weeks",
      "8-weeks",
    ],
  },
  "5th_weekend": {
    title: "5th Weekend",
    description: "One parent has the children every 5th weekend.",
    supportedIntervals: ["4-weeks", "8-weeks"],
  },
  custom: {
    title: "Custom",
    description: "A custom schedule that can be tailored to your needs.",
    supportedIntervals: [
      "1-week",
      "2-weeks",
      "3-weeks",
      "4-weeks",
      "5-weeks",
      "6-weeks",
      "7-weeks",
      "8-weeks",
    ],
  },
};
